module.exports = __webpack_public_path__ + "media/images/assign-ticket-8d73a615c438e6b40592ff87b1d24862.svg";